<script>
  import AdminNav from '@/components/admin/AdminNav.svelte';
  import { router } from '@inertiajs/svelte'

  let { reports = [], pagination = {}, filters = {}, stats = {}, flash = {} } = $props()

  // svelte-ignore state_referenced_locally
  const initialTypeFilter = filters.type || ''
  // svelte-ignore state_referenced_locally
  const initialStatusFilter = filters.status || ''
  // svelte-ignore state_referenced_locally
  const initialUrgencyFilter = filters.urgency || ''
  let typeFilter = $state(initialTypeFilter)
  let statusFilter = $state(initialStatusFilter)
  let urgencyFilter = $state(initialUrgencyFilter)

  function applyFilters() {
    const params = {}
    if (typeFilter) params.type = typeFilter
    if (statusFilter) params.status = statusFilter
    if (urgencyFilter) params.urgency = urgencyFilter
    router.get('/admin/reports', params, { preserveState: true })
  }

  function goToPage(page) {
    router.get('/admin/reports', { ...filters, page }, { preserveState: true })
  }

  function getStatusBadge(status) {
    switch (status) {
      case 'pending': return 'badge-warning'
      case 'processing': return 'badge-info'
      case 'resolved': return 'badge-success'
      case 'dismissed': return 'badge-neutral'
      default: return 'badge-neutral'
    }
  }

  function getStatusLabel(status) {
    const labels = { pending: '대기중', processing: '처리중', resolved: '처리완료', dismissed: '기각됨' }
    return labels[status] || status
  }

  function getReasonLabel(reason) {
    const labels = {
      spam_commercial:    '반복 홍보, 상업적 게시물',
      personal_info:      '개인정보 노출',
      illegal_content:    '불법 콘텐츠',
      csam:               '아동·청소년 성착취물',
      adult_content:      '성인물, 선정적 콘텐츠',
      hate_harassment:    '차별/모욕/괴롭힘',
      violence_self_harm: '폭력 위협/자해/자살',
      false_info:         '허위 정보',
      other:              '기타'
    }
    return labels[reason] || reason
  }

  function getTargetLabel(type) {
    switch (type) {
      case 'Post': return '게시글'
      case 'Comment': return '댓글'
      case 'User': return '사용자'
      default: return type
    }
  }

  function getUrgencyBadge(urgency) {
    switch (urgency) {
      case 'critical': return 'badge-error'
      case 'high':     return 'badge-warning'
      default:         return 'badge-neutral'
    }
  }

  function getUrgencyLabel(urgency) {
    const map = { critical: '긴급', high: '높음', normal: '보통' }
    return map[urgency] || urgency
  }
</script>

<AdminNav activeTab="reports" />

  <main>
    {#if flash.notice}
      <div class="mb-6 p-4 bg-success-light dark:bg-success/20 border border-success/30 rounded-xl text-success-dark dark:text-success text-body2">
        {flash.notice}
      </div>
    {/if}

    <!-- Stats -->
    <div class="flex flex-wrap items-center gap-3 mb-6">
      <h2 class="text-h1 text-content mr-3">신고 관리</h2>
      <div class="flex flex-wrap items-center gap-2 text-body2">
        {#if (stats.critical_count || 0) > 0}
          <button
            onclick={() => { urgencyFilter = 'critical'; applyFilters() }}
            class="px-3 py-1 bg-error/15 text-error border border-error/30 rounded-lg font-bold hover:bg-error/20 transition-colors cursor-pointer"
          >
            ⚠ 긴급 {stats.critical_count}건
          </button>
        {:else}
          <span class="px-3 py-1 bg-error/10 text-error/50 rounded-lg font-bold">긴급 0건</span>
        {/if}
        {#if (stats.high_count || 0) > 0}
          <button
            onclick={() => { urgencyFilter = 'high'; applyFilters() }}
            class="px-3 py-1 bg-warning-light dark:bg-warning/15 text-warning-dark dark:text-warning border border-warning/30 rounded-lg font-medium hover:bg-warning/20 transition-colors cursor-pointer"
          >
            높음 {stats.high_count}건
          </button>
        {:else}
          <span class="px-3 py-1 bg-surface-tertiary text-gray-400 rounded-lg font-medium">높음 0건</span>
        {/if}
        <span class="px-3 py-1 bg-warning-light dark:bg-warning/10 text-warning-dark dark:text-warning rounded-lg font-medium">
          전체 대기 {stats.total_pending || 0}건
        </span>
        <span class="px-3 py-1 bg-surface-tertiary text-content-secondary rounded-lg">
          오늘 {stats.total_today || 0}건
        </span>
      </div>
    </div>

    <!-- 정렬 안내 -->
    <p class="text-caption text-gray-400 dark:text-dark-text-disabled mb-4">
      긴급도 우선순위 기준 정렬됩니다 (긴급 → 높음 → 보통, 동일 긴급도 내 오래된 순)
    </p>

    <!-- Filters -->
    <div class="card card-bordered p-4 mb-6 shadow-md">
      <div class="flex flex-wrap items-center gap-4">
        <select bind:value={typeFilter} class="select">
          <option value="">모든 유형</option>
          <option value="post">게시글</option>
          <option value="comment">댓글</option>
          <option value="user">사용자</option>
        </select>

        <select bind:value={statusFilter} class="select">
          <option value="">모든 상태</option>
          <option value="pending">대기중</option>
          <option value="processing">처리중</option>
          <option value="resolved">처리완료</option>
          <option value="dismissed">기각됨</option>
        </select>

        <select bind:value={urgencyFilter} class="select">
          <option value="">모든 긴급도</option>
          <option value="critical">긴급</option>
          <option value="high">높음</option>
          <option value="normal">보통</option>
        </select>

        <button onclick={applyFilters} class="btn btn-primary btn-md">검색</button>
        {#if typeFilter || statusFilter || urgencyFilter}
          <button
            onclick={() => { typeFilter = ''; statusFilter = ''; urgencyFilter = ''; applyFilters() }}
            class="btn btn-secondary btn-md"
          >
            초기화
          </button>
        {/if}
      </div>
    </div>

    <!-- Reports Table -->
    <div class="card card-bordered overflow-hidden shadow-md">
      <table class="w-full">
        <thead class="bg-surface-tertiary">
          <tr>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">긴급도</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">신고 사유</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">대상</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">신고자</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">상태</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">AI 판정</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">신고일</th>
            <th class="px-6 py-3"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-dark-border">
          {#each reports as report}
            <tr class={`hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors ${
              report.urgency_level === 'critical' ? 'bg-error/3 dark:bg-error/5' : ''
            }`}>
              <td class="px-6 py-4">
                <span class={`badge ${getUrgencyBadge(report.urgency_level)}`}>
                  {getUrgencyLabel(report.urgency_level)}
                </span>
                {#if report.reason === 'csam'}
                  <span class="ml-1 text-error font-bold text-caption">CSAM</span>
                {/if}
              </td>
              <td class="px-6 py-4">
                <span class={`text-body1 font-medium ${
                  report.urgency_level === 'critical'
                    ? 'text-error'
                    : 'text-content'
                }`}>
                  {getReasonLabel(report.reason)}
                </span>
                {#if report.description}
                  <div class="text-caption text-content-tertiary truncate max-w-[200px]">{report.description}</div>
                {/if}
              </td>
              <td class="px-6 py-4">
                <span class="badge badge-neutral">{getTargetLabel(report.target_type)}</span>
              </td>
              <td class="px-6 py-4 text-body2 text-content-secondary">
                {report.reporter?.name || '익명'}
              </td>
              <td class="px-6 py-4">
                <span class={`badge ${getStatusBadge(report.status)}`}>{getStatusLabel(report.status)}</span>
              </td>
              <td class="px-6 py-4">
                {#if report.ai_verdict}
                  <span class={`badge ${report.ai_verdict === 'safe' ? 'badge-success' : report.ai_verdict === 'unsafe' ? 'badge-error' : 'badge-warning'}`}>
                    {report.ai_verdict}
                  </span>
                {:else}
                  <span class="text-caption text-gray-400">-</span>
                {/if}
              </td>
              <td class="px-6 py-4 text-body2 text-content-tertiary">
                {new Date(report.created_at).toLocaleDateString('ko-KR')}
              </td>
              <td class="px-6 py-4 text-right">
                <a href={`/admin/reports/${report.id}`} class="text-primary hover:text-primary-dark text-body2 font-medium">
                  상세보기
                </a>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>

      {#if reports.length === 0}
        <div class="text-center py-12 text-content-tertiary">
          검색 결과가 없습니다
        </div>
      {/if}
    </div>

    <!-- Pagination -->
    {#if pagination.total_pages > 1}
      <div class="flex items-center justify-center gap-2 mt-6">
        <button
          onclick={() => goToPage(pagination.current_page - 1)}
          disabled={pagination.current_page === 1}
          class="btn btn-secondary btn-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >이전</button>
        <span class="px-4 py-2 text-body2 text-content-tertiary">
          {pagination.current_page} / {pagination.total_pages}
        </span>
        <button
          onclick={() => goToPage(pagination.current_page + 1)}
          disabled={pagination.current_page === pagination.total_pages}
          class="btn btn-secondary btn-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >다음</button>
      </div>
    {/if}
  </main>
